import { render } from "./TNavComponent.vue?vue&type=template&id=ed5aa23a"
import script from "./TNavComponent.vue?vue&type=script&lang=js"
export * from "./TNavComponent.vue?vue&type=script&lang=js"

import exportComponent from "F:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__